import TablePage from '@/found/components/table_page';
import { VXETable } from 'vxe-table';
import request from '@/found/utils/request';
import _ from 'xe-utils';
// import Form from '../form';

export default {
  extends: TablePage,
  components: {
    // Form,
  },
  data() {
    return {};
  },

  created() {
    this.getConfigList('terminal_statistics_list');
  },
  methods: {

    modalClick({ val, row }) {
      if (val.code === 'view') {
        this.formConfig = { ...val, code: val.code, row };
        this.modalConfig = {
          title: '查看',
          // showFooter: true,
        };
        this.openFull();
      }
      return true;
    },
    setColumn(col) {
      console.log('col', col);
      const button = col;
      if (button.field === 'companyCodes') {
        button.isSearch = true;
        button.multiple = true;
        button.paramsName = 'orgName';
        button.paramsFixed = {
          ...button.paramsFixed,
          orgType: 'area',
          enableStatus: '009',
          pageNum: 1,
          pageSize: 1000,

        };
        button.apiUrl = '/mdm/mdmOrgController/pageList';
        button.optionsKey = {
          label: 'orgName',
          value: 'orgCode',
        };
      }
      if (button.field === 'orgCodes') {
        button.isSearch = true;
        button.multiple = true;
        button.paramsName = 'orgName';
        button.paramsFixed = {
          ...button.paramsFixed,
          enableStatus: '009',
          pageNum: 1,
          pageSize: 2000,
        };
        button.apiUrl = '/mdm/mdmOrgController/pageList';
        button.optionsKey = {
          label: 'orgName',
          value: 'orgCode',
        };
      }
      return { ...button };
    },
  },
};
